import React from 'react';

const Footer = ({copyright, logo, instagramUrl, facebookUrl, terms, privacy}) => {
    return (
      <footer >
    		<div className="topfooter text-center py-3">
          { logo!=='' ?
              <a href={process.env.REACT_APP_PREFIX_DIR}>
                <img
                  src={logo}
                  alt="MAX Delivery"
                  className="img-logo-login"
                  />
              </a>
            :
            null
          }
    		</div>
    		<div className="bottomfooter py-3">
    			<div className="container-fluid">
    				<div className="row">
        				<div className="col-sm-6 mb-1">
    						<div className="text-align-left">
    						 {copyright}

                 {
                   terms!=='' ?
                    <span style={{marginLeft:'10px', marginRight:'10px'}}>-</span>
                   :
                    null
                 }

                 {
                   terms!=='' ?
                    <a href={terms} target="_blank">Términos y condiciones</a>
                   :
                    null
                 }

                 {
                   privacy!=='' ?
                    <span style={{marginLeft:'10px', marginRight:'10px'}}>-</span>
                   :
                    null
                 }

                 {
                   privacy!=='' ?
                    <a href={privacy} target="_blank">Políticas de privacidad</a>
                   :
                    null
                 }

    						</div>
    					</div>
    					<div className="col-sm-6">
    						<div className="text-align-right socialfooter">
                  {
                    facebookUrl!=='' ?
                      <span><a href={facebookUrl}><i className="fa fa-facebook-square" aria-hidden="true"></i></a></span>
                    :
                      null
                  }
                  {
                    instagramUrl!=='' && facebookUrl!=='' ?
                      <span style={{marginLeft:'10px', marginRight:'10px'}}>-</span>
                    :
                      ''
                  }
                  {
                    instagramUrl!=='' ?
                      <span><a href={instagramUrl}><i className="fa fa-instagram" aria-hidden="true"></i></a></span>
                    :
                      null
                  }
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</footer>
    );
}

export default Footer;
